import {
  SET_NAV_LINK,
  UNSET_NAV_LINK,
  SUPPRESS_NAV,
  UN_SUPPRESS_NAV,
} from '../constants/NavConstants'

const initialState = {
  linkRoute: '',
  linkText: '',
  suppressNav: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NAV_LINK:
      return { ...state, linkRoute: payload.route, linkText: payload.text }
    case UNSET_NAV_LINK:
      return { ...state, linkRoute: '', linkText: '' }
    case SUPPRESS_NAV:
      return { ...state, suppressNav: true }
    case UN_SUPPRESS_NAV:
      return { ...state, suppressNav: false }
    default:
      return state
  }
}
